import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { InfoRounded } from "@mui/icons-material";

interface LocationCardPendingNoticeProps {
  /** ISO or formatted date string when the location was submitted for review. */
  submittedDate?: string;
}

const NoticeRoot = styled(Box)({
  background: "#fffbea",
  border: "1px solid #f0d060",
  borderRadius: 4,
  padding: "8px 12px",
  fontSize: "0.8571rem",  // 12px at 14px root
  color: "#856404",
  display: "flex",
  alignItems: "center",
  gap: 8,
  gridArea: "notice",
  marginTop: 12,
});

/**
 * Amber informational bar shown on Pending location cards.
 * Informs the supplier that the location is under admin review.
 */
const LocationCardPendingNotice = ({ submittedDate }: LocationCardPendingNoticeProps) => (
  <NoticeRoot role="status" aria-label="Pending review notice">
    <InfoRounded sx={{ fontSize: "1rem", color: "#c9960a", flexShrink: 0 }} aria-hidden="true" />
    <span>
      Submitted for SecurSpace admin review
      {submittedDate && <> on <strong>{submittedDate}</strong></>}.
      You will be notified once it is approved and goes live.
    </span>
  </NoticeRoot>
);

export default LocationCardPendingNotice;

